// removed by extract-text-webpack-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","brand":"_u4avc-WstuZP5sdbqIV1","brandText":"_2izS9cTaW_VFKhjr1SspfJ","footerNav":"BbjtnOg0if4xy_Tg001xE","footerSection":"_1Mjpl5E_-mMauX4WafQuYq","footerContent":"_1J33TgUq8YVho80v6afWR1","footerRow":"_3Eb3fftkVS_UQyQZB-GUNj","footerLogo":"_2Co7_JNmI0OFABbVJSI6lM","footerContact":"_1PINfVxmOOcMnBbZ-FH37m","footerCompany":"_2rlNCzD2JXVW2VEiYNgXPj","appContent":"gsYlqHuubB3bKiaXdybMG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.scss
 ** module id = 380
 ** module chunks = 0
 **/